export default "__VITE_ASSET__BtrqAqs8__"